import React, { useState, useEffect } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import activatedetailStyle from './ActivatedSchoolsOrgDetailsPage.module.css'
import logo from '../../../assets/images/demologo.png'
import BackBar from '../../components/BackBar/BackBar';
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";

export default function ActivatedSchoolsOrgDetailsPage() {
  const [coordinator, setCoordinator] = useState(null);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedProfilePic, setSelectedProfilePic] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [profilePreview, setProfilePreview] = useState(null);
  const [sendingId, setSendingId] = useState(null);
  const { id } = useParams();
  //console.log(id,'cid');
  useEffect(() => {


    const fetchCoordinatorData = async () => {
      try {

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?id=${id}`);
        const data = await response.json();

        if (data.success) {
          setCoordinator(data.coordinator);
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError('Failed to fetch coordinator data.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCoordinatorData();
  }, [id]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedLogo(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedProfilePic(file);
      setProfilePreview(URL.createObjectURL(file));
    }
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCoordinator({ ...coordinator, [name]: value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append("coordinator_id", id);
      formData.append("organization_name", coordinator.organization_name);
      formData.append("street_address", coordinator.st_address);
      formData.append("city", coordinator.city);
      formData.append("state", coordinator.state);
      formData.append("zipcode", coordinator.zipcode);
      formData.append("f_name", coordinator.f_name);
      formData.append("l_name", coordinator.l_name);
      formData.append("position", coordinator.position);
      formData.append("phone", coordinator.phone);
      formData.append("email", coordinator.email_id);

      if (selectedLogo) {
        formData.append("organization_logo", selectedLogo);
      }

      if (selectedProfilePic) {
        formData.append("profile_pic", selectedProfilePic);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/update_cordinator_admin_data.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.success) {
        Swal.fire({
          title: "Success",
          text: "School information updated successfully!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire("Error", "Update failed", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };


  const handleActivate = async (e, flag) => {
    e.preventDefault();
    let title = '';
    let text = '';
    let actionText = "";
    let apiFlag = "";
    if (flag == 1) {
      title = 'Coordinator Deactivation!';
      text = 'Coordinator Deativated Successfully!';
      flag = 'deactive';
      actionText = "deactivate";
      apiFlag = "deactive";
    }
    if (flag == 0) {
      title = 'Coordinator Activation!';
      text = 'Coordinator Activated Successfully!';
      flag = 'active';
      actionText = "activate";
      apiFlag = "active";
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${actionText} this coordinator?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionText} it!`,
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      // Make the API call to activate the school
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?cid=${id}&author_activate_cflag=${flag}`);
      const data = await response.json();
      if (data.success) {
        Swal.fire({
          title: title,
          text: text,
          icon: "success",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Redirect after pop-up
          // navigate(`/ActivatedSchoolsOrgPage`);
          window.location.reload();
        });
      }
      else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to activate or deactivate Cordinator!",
          icon: "error",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        })
      }
    } catch (error) {
      console.error('Error activating school:', error);
      alert('Failed to activate school. Please try again.');
    }
  };

  const handleSendContract = async (cordinatorId) => {
    try {
      setSendingId(cordinatorId);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/send_contract.php`,
        { cordinator_id: cordinatorId },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Contract Sent',
          text: 'The contract has been sent successfully.',
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: response.data.message || 'Failed to send contract.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while sending the contract.',
      });
    } finally {
      setSendingId(null);
    }
  };


  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <AdminHeader />
      <div className={activatedetailStyle.activatedschoolsorgdetailpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={`${activatedetailStyle.activatedschooldetailData} mb-4`}>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xl-4 col-xxl-4">
                      <h6>School/Organization Information</h6>
                      <div className={activatedetailStyle.activatedschoolboxData}>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>School/Organization Name</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="organization_name" onChange={handleChange} value={coordinator.organization_name} placeholder="Demo Elementary School" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>Street Address</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="st_address" onChange={handleChange} value={coordinator.st_address} placeholder="12345 Demo Street" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>City</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="city" onChange={handleChange} value={coordinator.city} placeholder="Manassas" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>State</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="state" onChange={handleChange} value={coordinator.state} placeholder="Virginia" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>Zip Code</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="zipcode" onChange={handleChange} value={coordinator.zipcode} placeholder="20109" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>School Logo</label>
                          <div className="col-sm-7">
                            <div className={`${activatedetailStyle.inputboxwhole} align-items-center`}>
                              <div
                                className={`${activatedetailStyle.inputboximageCircle} rounded-circle mb-2`}
                              >
                                <img
                                  src={
                                    logoPreview ||
                                    `${process.env.REACT_APP_API_BASE_URL}authormeetapi/${coordinator.organization_logo}`
                                  }
                                  className="img-fluid"
                                  onClick={() => document.getElementById("logoInput").click()}
                                  style={{ cursor: "pointer" }}
                                  alt="logo"
                                />

                                <input
                                  type="file"
                                  id="logoInput"
                                  style={{ display: "none" }}
                                  accept="image/*"
                                  onChange={handleLogoChange}
                                />
                              </div>

                              <button
                                type="button"
                                className={activatedetailStyle.mainupdateButton}
                                onClick={handleSubmit}
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <h6>Coordinator Details</h6>
                      <div className={activatedetailStyle.activatedcordinatorboxData}>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-4 form-label`}>Name</label>
                          <div className="col-sm-8">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="profile_name" onChange={handleChange} value={`${coordinator.f_name} ${coordinator.l_name}`} placeholder="Mark Zuckerberg" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-4 form-label`}>Position</label>
                          <div className="col-sm-8">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="position" onChange={handleChange} value={coordinator.position} placeholder="Librarian" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-4 form-label`}>Phone Number</label>
                          <div className="col-sm-8">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} name="phone" onChange={handleChange} value={coordinator.phone} placeholder="123-456-7890" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-4 form-label`}>Email</label>
                          <div className="col-sm-8">
                            <input type="email" className={`${activatedetailStyle.inputboxformControl} form-control`} name="email_id" onChange={handleChange} value={coordinator.email_id} placeholder="email@email.com" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-4 form-label`}>Profile Image</label>
                          <div className="col-sm-8">
                            <div className={`${activatedetailStyle.inputboxwhole} align-items-center`}>
                              <div
                                className={`${activatedetailStyle.inputboximageCircle} rounded-circle mb-2`}
                              >
                                <img
                                  src={
                                    profilePreview ||
                                    `${process.env.REACT_APP_API_BASE_URL}authormeetapi/${coordinator.profile_pic}`
                                  }
                                  className="img-fluid"
                                  onClick={() => document.getElementById("profileInput").click()}
                                  style={{ cursor: "pointer" }}
                                  alt="profile"
                                />

                                <input
                                  type="file"
                                  id="profileInput"
                                  style={{ display: "none" }}
                                  accept="image/*"
                                  onChange={handleProfileChange}
                                />
                              </div>

                              <button
                                type="button"
                                className={activatedetailStyle.mainupdateButton}
                                onClick={handleSubmit}
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <h6>Password Information</h6>
                      <div className={activatedetailStyle.activatedpasswordboxData}>
                        <div className="mb-2 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>Password</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl}  form-control`} name="password" onChange={handleChange} value={coordinator.password} readOnly />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${activatedetailStyle.inputboxformLabel} col-sm-5 form-label`}>Confirm Password</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${activatedetailStyle.inputboxformControl} form-control`} value={coordinator.password} readOnly />
                          </div>
                        </div>
                        <h6 className="pb-3">Contract Status</h6>
                        {/*<div className="mb-3 row">
                      <div className="col-sm-12 text-center">
                        <button className={`${activatedetailStyle.signedButton} btn btn-success`} type="button">Signed</button>
                        <p className={activatedetailStyle.signedupdateText}>Updated: 04/01/2026</p>
                        <button className={`${activatedetailStyle.contractresendButton} btn btn-primary`} type="button" onClick={() => handleSendContract(coordinator.cordinator_id)} >Resend Contract</button>
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <div className="col-sm-12 text-center">

                            {/* STATUS BUTTON */}
                            <button
                              className={`btn ${coordinator.contract_status === "signed" ? `${activatedetailStyle.signedButton} btn btn-success`
                                : coordinator.contract_status === "signed" ? `${activatedetailStyle.signedButton} btn btn-success` : `${activatedetailStyle.notsignedButton} btn btn-danger`}`} type="button" disabled
                            >
                              {coordinator.contract_status === "signed"
                                ? "Signed"
                                : coordinator.contract_status === "signed"
                                  ? "Sent"
                                  : "Not Signed"}
                            </button>

                            {/* Updated Date */}
                            {coordinator.contract_signed_at && (
                              <p className={activatedetailStyle.signedupdateText}>
                                Updated: {coordinator.contract_signed_at}
                              </p>
                            )}

                            {/* ACTION BUTTON */}
                            <button
                              className={`${activatedetailStyle.contractresendButton} btn btn-primary`}
                              type="button"
                              onClick={() => {
                                if (coordinator.contract_status === "signed") {
                                  const encodedId = btoa(coordinator.cordinator_id);
                                  navigate(`/view-contract/${encodedId}`);
                                } else {
                                  handleSendContract(coordinator.cordinator_id);
                                }
                              }}
                            >
                              {coordinator.contract_status === "signed"
                                ? "View Contract"
                                : coordinator.contract_status === "signed"
                                  ? "Resend Contract"
                                  : "Send Contract"}
                            </button>

                          </div>
                        </div>

                        <div className="d-flex">
                          <h6 className="me-3">Activation Status</h6>
                          <div>
                            <div className="form-check form-switch">
                              <input className="form-check-input" type="checkbox" id="activate" onClick={(e) => handleActivate(e, 0)} checked={coordinator.status == 0} />
                              <label className={`${activatedetailStyle.inputboxformLabel} form-check-label`} for="activate">Activate</label>
                            </div>
                            <div className="form-check form-switch">
                              <input className="form-check-input" type="checkbox" id="deactivate" onClick={(e) => handleActivate(e, 1)} checked={coordinator.status == 1} />
                              <label className={`${activatedetailStyle.inputboxformLabel} form-check-label`} for="deactivate">Deactivate</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}